<template>
  <section class="viewsrhqySuspectVehicle_List space-y-2 p-4">
    <viewTitle title="业务管理 / 车辆嫌疑名单" :showReturn="false" />
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item>
        <el-button
          v-has="['c-base-mp-bd-create']"
          @click="onAdd"
          size="small"
          type="primary"
          >新增</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          v-model="queryParam.keyword"
          placeholder="请输入关键字"
          class="w-60"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="refreshData" size="small">刷新数据</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :isIndex="false"
      :isSelection="false"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="booking_id"
      @loadPage="loadData"
    >
      <template slot="create_time" slot-scope="{ row }">
        {{ row.create_time | timeFormat }}
      </template>
      <template slot="update_time" slot-scope="{ row }">
        {{ row.update_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="dropdown" @click.stop v-has="['c-base-mp-bd-update', 'c-base-mp-bd-delete']">
          <el-dropdown trigger="click" :hide-on-click="true">
            <span class="el-dropdown-link">
              操作
              <span class="el-icon-arrow-down"></span>
            </span>
            <el-dropdown-menu slot="dropdown" ref="dropdown">
              <el-dropdown-item v-has="['c-base-mp-bd-update']" @click.native.stop="onEdit(row)">
                修改
              </el-dropdown-item>
              <el-dropdown-item v-has="['c-base-mp-bd-delete']" @click.native.stop="onDelete(row, 1)">
                删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </c-table>
    <form-modal @ok="refreshData" ref="formModal" />
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import formModal from "./components/formModal.vue";
export default {
  data() {
    return {
      columns: [
        {
          label: "类型",
          prop: "type",
          formatData: row => (row.type == 1 ? "嫌疑车辆名单" : "--")
        },
        { label: "黑名单信息", prop: "license_plate" },
        { label: "创建时间", prop: "create_time" },
        { label: "更新时间", prop: "update_time" },
        { width: 120, label: "操作", prop: "action" }
      ],
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_beidou_car"
      },
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/query_beidou_car",
          data: params
        });
      }
    };
  },
  components: {
    formModal
  },
  mixins: [initListMinxin],
  methods: {
    onAdd() {
      this.$refs.formModal.onOpen();
    },
    onEdit(row) {
      this.$refs.formModal.onOpen(row);
    },
    onDelte() {}
  }
};
</script>
<style lang="less" scoped></style>
